module.exports = __webpack_public_path__ + "img/logo-4.a1466249.png";